module.exports = __webpack_public_path__ + "static/media/search-icon.e6067082.svg";